export const getEmploymentsFrag = `
    id
    dateFrom
    dateTo
    serviceId
    service {
        name
    }
    employmentTypeName
    organizationId
    
    
    contract
    specificName
    workloadType
    workloadSize
    scopeOfWork
    note
    workplaces {
        workplaceId
        dateFrom
        dateTo
    }
`;
// TODO Bottom fields should not be there, but no time to refactor dialog
